import { lazy } from 'react';

import { Loadable } from 'components/loaders/Loadable.js';

const Samples = Loadable(lazy(() => import('pages/samples.js')));
const Error404 = Loadable(lazy(() => import('pages/404.js')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <Samples />
    },
    {
      path: 'invitation',
      element: <Samples />
    },
    // Catch-all route for 404
    {
      path: '*',
      element: <Error404 />
    }
  ]
};

export default MainRoutes;
